import { AxiosResponse } from 'axios'
import { queryOptions } from '@tanstack/react-query'
import { NBoardRoomEvents } from '../interfaces/services/boardroom-events.interfaces'
import { createUrl } from './helpers'
import axiosAuth from './config'

export const getBoardRoomEventsPerSociety = (
  societyId: string
): Promise<AxiosResponse<NBoardRoomEvents.NGetPerSocieties.IResponse>> => {
  const body: NBoardRoomEvents.NGetPerSocieties.IRequestBody = {
    societyIds: [societyId],
  }
  return axiosAuth.post<NBoardRoomEvents.NGetPerSocieties.IResponse>(
    createUrl('/boardroom-events/get-per-societies'),
    body
  )
}

export const getBoardRoomEvent = (
  id: string
): Promise<AxiosResponse<NBoardRoomEvents.NGetById.IResponse>> => {
  return axiosAuth.get<NBoardRoomEvents.NGetById.IResponse>(
    createUrl(`/boardroom-events/event/${id}`)
  )
}

export const createBoardRoomEvent = (
  body: NBoardRoomEvents.NCreate.IRequestBody
): Promise<AxiosResponse<NBoardRoomEvents.NCreate.IResponse>> => {
  return axiosAuth.post<NBoardRoomEvents.NCreate.IResponse>(
    createUrl(`/boardroom-events/event`),
    body
  )
}

export const updateBoardRoomEvent = (params: {
  id: string
  body: NBoardRoomEvents.NPatch.IRequestBody
}): Promise<AxiosResponse<NBoardRoomEvents.NPatch.IResponse>> => {
  return axiosAuth.patch<NBoardRoomEvents.NPatch.IResponse>(
    createUrl(`/boardroom-events/event/${params.id}`),
    params.body
  )
}

export const deleteBoardRoomEvent = (variables: {
  id: string
  queryParameters: NBoardRoomEvents.NDel.IRequestQuery
}): Promise<AxiosResponse<NBoardRoomEvents.NDel.IResponse>> => {
  return axiosAuth.delete<NBoardRoomEvents.NDel.IResponse>(
    createUrl(`/boardroom-events/event/${variables.id}`, {
      ...variables.queryParameters,
    })
  )
}

export const boardRoomEventAttendance = (
  id: string,
  body: NBoardRoomEvents.NAttendance.IRequestBody
): Promise<AxiosResponse<NBoardRoomEvents.NAttendance.IResponse>> => {
  return axiosAuth.post<NBoardRoomEvents.NAttendance.IResponse>(
    createUrl(`/boardroom-events/event/${id}/attendance`),
    body
  )
}

export const getBoardroomEventAttendanceList = async (
  id: string
): Promise<AxiosResponse<NBoardRoomEvents.NGetAttendanceList.IResponse>> => {
  return axiosAuth.get<NBoardRoomEvents.NGetAttendanceList.IResponse>(
    createUrl(`/boardroom-events/event/${id}/attendance-list`)
  )
}

export const boardRoomEventQueries = {
  getEvent: (eventId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'boardroomEvents', entity: 'detail', eventId }],
      queryFn: async ({ queryKey }) =>
        (await getBoardRoomEvent(queryKey[0].eventId!)).data.data,
      enabled: !!eventId,
    }),
  getEventsPerSociety: (societyId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'boardroomEvents', entity: 'list', societyId }],
      queryFn: async ({ queryKey }) => {
        return (await getBoardRoomEventsPerSociety(queryKey[0].societyId!)).data
          .data
      },
      enabled: !!societyId,
    }),
}
